import type { ReactNode } from "react";
import { FormItemWrapper } from "../../DefaultEditorV2/FormItemWrapper";

export const FieldWrapper = ({ children }: { children: ReactNode }) => (
  <FormItemWrapper className="bg-tertiary flex items-center justify-between gap-2 rounded-xl p-1.5">
    {children}
  </FormItemWrapper>
);
